import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { CandidatesBulkSms } from './candidates-bulk-sms.interface';
import { CandidatesBulkSmsService } from './candidates-bulk-sms.service';
const service = new CandidatesBulkSmsService();

export interface CandidatesBulkSmsState {}

const CandidatesBulkSmsStore: Module<CandidatesBulkSmsState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async sendCandidatesBulkSms(context, candidatesBulkSms: CandidatesBulkSms) {
         return await service.sendCandidatesBulkSms(candidatesBulkSms);
      },
   },
};

export default CandidatesBulkSmsStore;
